export default __webpack_public_path__ + "static/media/icon-identification-back-uploader.78e04ac5.svg";